.wrapper {
  padding-top: 30px;
  padding-left: 36px;

  .sub-wrapper {
    padding: 0px;

    #create-text {
      text-align: justify;
      width: 600px;
      margin-bottom: 24px;
    }

    #console-text,
    #invitation-text {
      text-align: justify;
      width: 500px;
      margin-bottom: 24px;
    }

    #expired-tooltip {
      width: 500px;
      height: 48px;
      margin-bottom: 40px;

      border: 1px solid var(--orange-layout-050-warning);
      border-radius: 4px;

      display: flex;
      align-items: center;

      .icon {
        margin: 12px 16px;
        height: 24px;
        width: 24px;

        color: var(--orange-layout-050-warning);
        font-size: 22px;
      }

      #expired-tooltip-text {
        font-size: var(--body-size);
        color: var(--body-text-arrows-400);
      }
    }

    #console-button {
      margin-bottom: 24px;
    }
  }

  gz-progress-spinner {
    display: none;
  }

  &.is-loading {
    .sub-wrapper {
      display: none;
    }

    gz-progress-spinner {
      display: block;
    }
  }
}
